<template>
  <div class="question-item bg-white box-border px-4 relative">
    <!-- unknown-wrap 只有在量表生效 -->
    <div :class="{ 'unknown-wrap': showUnknownWrap }">
      <div ref="title" class="q-title leading-base break-words" v-html="title"></div>
    </div>
    <div class="q-desc-wrap" :class="[isOverFlowNote ? 'pb-8' : '']">
      <div ref="note" class="q-desc text-medium break-words leading-base pl-5 mt-1" :class="getNoteClass" v-if="showNote">
        <div v-html="question.note"></div>
      </div>
      <div v-if="isOverFlowNote" class="operate-btn" @click="isOpenNote = !isOpenNote">
        <span class="text-theme">{{ isOpenNote ? '收起' : '展开' }}</span>
        <van-icon :name="isOpenNote ? 'arrow-up' : 'arrow-down'"></van-icon>
      </div>
    </div>
    <div class="q-content mt-2" ref="qContent">
      <component :is="componentName" :question="question"></component>
    </div>
    <template v-if="content.allowPhotoNum && content.allowPhotoNum > 0">
      <adapter-upload-files :content="content" />
    </template>
  </div>
</template>

<script>
import { componentMap, typeMapping ,questionType} from 'dygc'
import { components } from '@/questions'
import AdapterUploadFiles from '@/questions/components/AdapterUploadFiles'
import { previewImage } from '@/assets/js/preview-image'

export default {
  name: 'Question',
  components: { AdapterUploadFiles, ...components },
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isOpenNote: false,
      isOverFlowNote: true
    }
  },
  computed: {
    showUnknownWrap(){
      if(!this.question.issue.show_unknown) return false
      // 只有单行量表才需要在标题加 不清楚按钮
      return [questionType.SCALE,questionType.NPS_SCALE].includes(this.question.questionType)
    },
    showUploadFile() {
      let content = this.question.content
      return content.allowMinPhotoNum !== 0 || content.allowPhotoNum !== 0
    },
    title() {
      const content = this.question.content
      return content.richText || content.text
    },
    content() {
      return this.question.content
    },
    componentName() {
      if (this.question.issue.getComponentType) {
        return this.question.issue.getComponentType()
      } else {
        return componentMap.get(this.question.questionType)
      }
    },
    showNote() {
      if (!this.question.setting.enableNote) return false
      return !!this.question.note
    },
    getNoteClass() {
      if (!this.question.setting.enableFold) return ''
      if (!this.isOverFlowNote) return ''
      return this.isOpenNote ? '' : 'fixed-height-note'
    }
  },
  methods: {
    initTitle() {
      let child = this.$refs.title.childNodes[0]
      let el = child
      if (child.nodeType !== 1) {
        el = this.$refs.title
      }
      const nodes = []
      const enableQuestionIndex = this.$bus.enableQuestionIndex
      if (enableQuestionIndex && this.question.num) {
        let span = document.createElement('span')
        span.innerText = `${this.question.num}.`
        span.className = 'mr-1'
        nodes.push(span)
      }
      if (this.question.required) {
        let span = document.createElement('span')
        span.innerText = '*'
        span.className = 'text-red mr-1'
        nodes.push(span)
      }
      for (const node of nodes) {
        el.insertBefore(node, el.childNodes[0])
      }
      if (this.question.issue.defaultTip) {
        const span = document.createElement('span')
        span.innerText = `【${this.question.issue.defaultTip}】`
        el.appendChild(span)
      }

      if (this.hasAnswerScore) {
        const span = document.createElement('span')
        span.innerHTML = `<span>${this.totalScore} 分</span>`
        span.className = 'text-theme-black-450 px-2 leading-22 rounded-small ml-2'
        el.appendChild(span)
      }
      // const typeText = typeMapping.get(this.question.questionType)
      // if (this.$bus.enableQuestionType && typeText) {
      //   const span = document.createElement('span')
      //   span.innerHTML = `【${typeText}】`
      //   span.className = 'bg-theme-100 text-theme-700 leading-base rounded-small ml-2'
      //   el.appendChild(span)
      // }
      const title = this.$refs.title
      previewImage(title)
      if(this.$refs.qContent) {
        previewImage(this.$refs.qContent)
      }
      let note = this.$refs.note
      if (note) {
        this.isOverFlowNote = note.clientHeight < note.scrollHeight
      } else {
        this.isOverFlowNote = false
      }
    }
  },
  mounted() {
    this.initTitle()
  }
}
</script>

<style scoped></style>
